import Container from '../../atoms/container/modalButtons';
import Focus from '../../../../shared/types/enums/focus';
import ModalButton from '../../atoms/buttons/modalButton';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import useKeyboard from '../../../../shared/components/utils/hooks/useKeyboard';
import {
  clearModal,
  modalSelector,
} from '../../../../shared/store/slices/modal.slice';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import {
  popFocus,
  pushFocus,
} from '../../../../shared/store/slices/focus.slice';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import { useEffect } from 'react';

function GenericErrorModalButtons() {
  const dispatch = useAppDispatch();
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { params } = useAppSelector(modalSelector);
  const buttonText =
    (params.buttonText as string) ||
    TranslationManager.get('MODAL.GENERIC_ERROR.CLOSE');

  const closeError = () => {
    dispatch(popFocus());
    dispatch(clearModal());
  };

  // Effect hooks

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
    return () => {
      dispatch(popFocus());
    };
  }, []);

  // Keyboard hooks

  useKeyboard({
    focus: Focus.MODAL_BUTTONS,
    stopPropagation: true,
    keyDownHandler: (key: string) => {
      switch (key) {
        case 'BACK':
        case 'SELECT':
          closeError();
          break;
      }
    },
  });

  return (
    <Container>
      <ModalButton focused={!enabled} onClick={() => closeError()}>
        {buttonText}
      </ModalButton>
    </Container>
  );
}

export default GenericErrorModalButtons;
